import * as $ from 'jquery';

export default class SearchPage {
    private readonly  $holder: JQuery;

    private ACTIVE_CLASS = 'active';
    private HAS_VALUE_CLASS = 'has-value';

    private selectors = {
        btnMore: '.js-load-more-search-items',
        searchItems: '.js-search-items',
        filterItem: '.js-search-item-filter-name',
        filterItemAll: '.js-search-item-filter-name-all',
        searchItemName: '.js-search-item-block-name',
        searchItem: '.js-search-item-block',
        searchField: '.js-search-panel-field',
        searchFieldWrapper: '.js-search-panel-wrapper',
    };

    constructor($container: JQuery) {
        this.$holder = $container;

        this.init();
    }

    private init(): void
    {
        this.showAllResultHandler = this.showAllResultHandler.bind(this);
        this.toggleSearchMenuItemHandler = this.toggleSearchMenuItemHandler.bind(this);
        this.initEvents();
    }

    private initEvents(): void
    {
        this.$holder.on('click', this.selectors.btnMore, (event) => {
            const $button = $(event.currentTarget);
            const $groupHolder = $button.closest(this.selectors.searchItems);
            const url = $groupHolder.data('url');

            $button.hide();
            $.ajax({
                url: url,
                type: 'GET',
                cache: false,
                success: (result: any) => {
                    $groupHolder.append(result.html);
                },
                error: (error) => {
                    console.log('Ошибка:', error);
                }
            });
        });

        const $inputValue = this.$holder.find(this.selectors.searchField).val()
        $inputValue
            ? this.$holder.find(this.selectors.searchFieldWrapper).addClass(this.HAS_VALUE_CLASS)
            : this.$holder.find(this.selectors.searchFieldWrapper).removeClass(this.HAS_VALUE_CLASS);

        //клик по меню
        $(this.selectors.filterItem).on('click', this.toggleSearchMenuItemHandler);

        //показать все результаты
        $(this.selectors.filterItemAll).on('click', this.showAllResultHandler);
    }

    /**
     * Обработчик клика по меню из списка поиска
     * @param event
     */
    private toggleSearchMenuItemHandler(event: JQuery.ClickEvent): void {
        event.preventDefault();
        const $target = $(event.currentTarget);
        $(this.selectors.filterItemAll).removeClass(this.ACTIVE_CLASS);
        $(this.selectors.filterItem).removeClass(this.ACTIVE_CLASS);
        $target.addClass(this.ACTIVE_CLASS);
    }

    /**
     * Показывает все результаты
     * @param evt
     */
    private showAllResultHandler(evt: JQuery.ClickEvent): void {
        $(this.selectors.filterItem).removeClass(this.ACTIVE_CLASS);
        $(this.selectors.filterItemAll).addClass(this.ACTIVE_CLASS);
    }

}
